// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type MissingPaymentsRow } from '../../brokers/needs_attention/types'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type ModifyNAVItemsParams = {
  broker_ids_to_add?: string[]
  broker_ids_to_remove?: string[]
  tag_ids_to_add?: string[]
  tag_ids_to_remove?: string[]
  silence_until_date?: string
  content?: string
  attempt_to_resolve?: boolean
}

export function useModifyNAVItems ({ ids } : { ids: string[] }) {
  return useMutation<MissingPaymentsRow[], GrapeAPIErrorType, ModifyNAVItemsParams>({
    mutationFn: async (params) => {
      const request = new FetchRequest(
        'patch',
        '/api/web/brokers/broker_attention_needed_items',
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: {
            broker_attention_needed_item_ids: ids,
            ...params,
          },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
